import React from "react";
import "../../../../src/assets/css/style.css";

export default function English() {
  return (
    <>
      <section className="page-content--bge55" style={{ paddingLeft: "10px", paddingRight: "10px", paddingTop: "10px", paddingBottom: "10px" }}>
        <div className="container-fluid" style={{ paddingLeft: "10px", paddingRight: "10px" }}>
          <div className="row">
            <div className="col-md-12">
              <h3 className="head2 reatiler text-center">Terms & Conditions</h3>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card" style={{ padding: "14px 10px" }}>
                <ul className="tnclist" style={{ paddingLeft: "20px", paddingRight: "10px" }}>
                  <li>
                    This Retailer Loyalty Program belongs to Sintex BAPL
                    Limited, a part of the Welspun Group, for its Water Storage
                    Tanks business.
                  </li>
                  <li>This program will be effective from 01 July 2023.</li>
                  <li>
                    The program is open for enrolment of Retailers who buy
                    directly from the assigned Distributor.
                  </li>
                  <li>
                    To qualify for rewards accrual and redemption, the retailer
                    must be registered and verified in our system.
                  </li>
                  <li>
                    Enrolling for this Program by submitting the duly filled and
                    signed verification documents to Sintex is mandatory and
                    will be deemed as acceptance of these terms and conditions.
                  </li>
                  <li>
                    This Retailer Loyalty Program is only applicable for Retail
                    sales made by the company to the distributor. Please contact
                    your Sintex representative for a detailed clarification.
                  </li>
                  <li>
                    Only purchases made from the assigned distributor would be
                    considered for benefits under this program.
                  </li>
                  <li>
                    Retailers have to ensure that billing should be done through
                    Sintex Shikhar DMS as rewards will be considered only for
                    sales done through Sintex Shikhar DMS from their associated
                    Distributor.
                  </li>
                  <li>
                    Any related party or sister concern of a distributor, or own
                    firm of distributor cannot be part of this scheme. The
                    assessment of Sintex Management in this regard will be final
                    and binding to all channel partners.
                  </li>
                  <li>
                    CWUG (FRP tanks), HD, LIDs or any other products which are
                    not mentioned will not be considered in the loyalty program.
                  </li>
                  <li>
                    Sintex may assign targets from time to time for eligible
                    retailers to qualify and earn rewards.
                  </li>
                  <li>
                    Misrepresentation and wrong information will result in
                    permanent disqualification from the program and schemes run
                    by Sintex.
                  </li>
                </ul>

                <h4 style={{ margin: "20px 0 10px 0", fontWeight: "bold", fontSize: "16px" }}>
                  Data Privacy &amp; Protection (DPDP Act, 2023)
                </h4>

                <ul className="tnclist" style={{ paddingLeft: "20px", paddingRight: "10px" }}>
                  <li>
                    Sintex BAPL Limited shall act as the Data Fiduciary under the
                    Digital Personal Data Protection Act, 2023 (DPDP Act) with
                    respect to the personal data collected under this Retailer
                    Loyalty Program. By registering for the Program, the
                    Retailer provides free, informed, specific, and unambiguous
                    consent for the collection, storage, use, processing, and
                    management of personal data for the purposes stated herein.
                  </li>
                  <li>
                    Personal data collected under the Program may include, but
                    is not limited to, Retailer Name, Mobile Number, WhatsApp
                    Number, Email Address, PAN Number, GST Number, Shop/Firm
                    Name, Distributor Details, Billing Information, Reward
                    Transactions, Redemption Details, Communication Preferences,
                    and any other information required for administration of the
                    Program.
                  </li>
                  <li>
                    The collected personal data may be used for Retailer
                    verification, Program administration, reward computation,
                    reward redemption, customer support, communication regarding
                    the Program, compliance with legal and regulatory
                    requirements, business analytics, fraud prevention, and
                    audit purposes.
                  </li>
                  <li>
                    Sintex may share personal data with its employees,
                    affiliates, authorized distributors, technology service
                    providers, logistics partners, reward fulfillment agencies,
                    auditors, and other authorized third-party service providers
                    strictly for the purpose of operating and administering the
                    Program.
                  </li>
                  <li>
                    Sintex may maintain records of Retailer consent,
                    communication preferences, opt-ins, and opt-outs for
                    compliance, audit, and regulatory purposes as required under
                    applicable laws.
                  </li>
                  <li>
                    Sintex shall implement reasonable technical and
                    organizational security measures to protect personal data
                    from unauthorized access, disclosure, alteration, or misuse.
                  </li>
                  <li>
                    As a Data Principal under the DPDP Act, 2023, the Retailer
                    shall have the right to seek access to personal data, request
                    correction of inaccurate information, request erasure of
                    personal data where permissible under law, withdraw consent,
                    and raise grievances regarding the processing of personal
                    data.
                  </li>
                  <li>
                    Retailers may withdraw their consent for processing of
                    personal data by contacting Sintex through the designated
                    support channel. However, withdrawal of consent may result
                    in suspension, restriction, or termination of participation
                    in the Retailer Loyalty Program.
                  </li>
                  <li>
                    By enrolling in the Program, the Retailer agrees to receive
                    transactional communications including OTPs, account
                    verification messages, reward updates, redemption
                    confirmations, account statements, service notifications,
                    and other communications necessary for the operation of the
                    Program.
                  </li>
                  <li>
                    Promotional and marketing communications shall be sent only
                    in accordance with applicable laws and regulatory
                    requirements. Retailers may opt out of promotional
                    communications at any time without affecting their
                    participation in the Program.
                  </li>
                  <li>
                    In the event of any personal data breach requiring
                    notification under applicable law, Sintex shall take
                    appropriate remedial measures and provide notifications as
                    required under the DPDP Act, 2023.
                  </li>
                  <li>
                    Any grievance, request for access, correction, deletion,
                    consent withdrawal, or privacy-related complaint may be
                    submitted to the designated Grievance Officer / Data
                    Protection Contact of Sintex.
                  </li>
                </ul>

                <ul className="tnclist" style={{ paddingLeft: "20px", paddingRight: "10px" }}>
                  <li>
                    The company shall deduct TDS on the equivalent value of all
                    rewards in accordance with Section 194R of the Income Tax Act
                    1961. Retailer is responsible to provide Permanent Account
                    Number (PAN) details.
                  </li>
                  <li>
                    Neither this program, nor its Terms and Conditions shall be
                    construed as distributorship, joint venture, agency
                    relationship or as granting of franchisee.
                  </li>
                  <li>
                    Sintex reserves the right to disqualify any Retailer from
                    the program and any other Company or agency run program,
                    without assigning any reason / intimation / justification
                    thereof.
                  </li>
                  <li>
                    Sintex reserves the right for the computation of the reward
                    that shall be final, conclusive and binding on the Retailer
                    and will not be liable to be disputed or challenged.
                  </li>
                  <li>
                    Sintex or its agency is not responsible for delays in
                    courier / post for the claims / documentation to be received
                    as part of the KYC formalities.
                  </li>
                  <li>Benefits under the program are non-transferable.</li>
                  <li>
                    There is no upper limit on the accumulation of the reward
                    points and the accumulation is correlated to the purchase of
                    Sintex WST products.
                  </li>
                  <li>
                    Rewards already credited may be reversed, adjusted, or
                    cancelled in case of product returns, credit notes, debit
                    notes, cancelled invoices, duplicate invoices, billing
                    corrections, fraudulent transactions, disputed sales, or any
                    transaction subsequently found to be ineligible under the
                    program.
                  </li>
                  <li>
                    Sintex reserves the right to suspend, block, reverse
                    rewards, or terminate participation where fraudulent
                    activity, invoice manipulation, artificial billing,
                    collusive transactions, fake purchases, duplicate claims,
                    misuse of distributor accounts, or any activity intended to
                    gain unfair benefits is detected.
                  </li>
                  <li>
                    Reward eligibility shall be subject to successful
                    realization of payment against eligible invoices. Sintex
                    reserves the right to withhold, reverse, or adjust rewards
                    against unpaid, overdue, disputed, cancelled, or dishonoured
                    transactions.
                  </li>
                  <li>
                    Sintex may temporarily suspend reward accrual, redemption,
                    or account access during investigation of discrepancies,
                    fraud review, KYC verification, legal proceedings,
                    compliance checks, or operational audits.
                  </li>
                  <li>
                    Expired reward points shall automatically lapse upon expiry
                    and shall not be reinstated, transferred, exchanged, or
                    compensated in any form.
                  </li>
                  <li>
                    Sintex reserves the right to revise reward catalogues,
                    redemption values, reward conversion ratios, reward point
                    values, redemption thresholds, reward structures, and
                    eligibility criteria at its sole discretion.
                  </li>
                  <li>
                    All rewards are subject to availability. In the event a
                    reward is unavailable, discontinued, or out of stock,
                    Sintex reserves the right to substitute the reward with
                    another reward of equivalent value without prior notice.
                  </li>
                  <li>
                    Applicable taxes, including Tax Deducted at Source (TDS) on
                    benefits, perquisites, rewards, incentives, gifts, trips, or
                    any other program benefits under the provisions of the
                    Income-tax Act, 1961, the Income-tax Act, 2025, and/or any
                    subsequent amendments, re-enactments, notifications,
                    circulars, or applicable laws, shall be borne by the
                    retailer. Sintex reserves the right to deduct, collect,
                    withhold, recover, or adjust any applicable taxes prior to
                    reward issuance, redemption, or benefit fulfilment. Failure
                    to comply with applicable tax requirements or furnish valid
                    PAN and other required documents may result in withholding,
                    suspension, cancellation, or forfeiture of rewards and
                    benefits under the Program.
                  </li>
                  <li>
                    Sintex reserves the right to verify invoices, purchase
                    records, payment records, tax documents, KYC documents,
                    distributor transactions, and any other supporting records
                    at any time for determining reward eligibility and
                    compliance with the program.
                  </li>
                  <li>
                    Sintex reserves the right to modify, suspend, discontinue,
                    merge, restructure, or terminate the program at any time. In
                    the event of program closure or discontinuation, Sintex may
                    prescribe a redemption period after which any unredeemed
                    rewards shall automatically lapse without any liability.
                  </li>
                  <li>
                    Any rewards, points, or benefits credited due to system
                    errors, technical issues, data discrepancies, operational
                    mistakes, or processing errors may be reversed, recovered,
                    or adjusted by Sintex without prior notice.
                  </li>
                  <li>
                    Sintex shall not be liable for any delay, interruption, or
                    failure in the operation of the program arising from events
                    beyond its reasonable control, including but not limited to
                    natural disasters, pandemics, government actions, strikes,
                    civil disturbances, technical failures, or force majeure
                    events.
                  </li>
                  <li>
                    Sintex's records, calculations, and determination relating
                    to purchases, reward accrual, reward balances, eligibility,
                    redemptions, and program benefits shall be final, conclusive,
                    and binding on all participants.
                  </li>
                  <li>
                    Failure to provide valid PAN, GST, KYC documents, or any
                    other information or documentation requested by Sintex may
                    result in suspension from the program, withholding of
                    rewards, restriction of redemption, or termination of
                    participation.
                  </li>
                  <li>
                    In case of any discrepancy relating to purchases, invoice
                    entries, reward accrual, reward balances, or redemptions,
                    the retailer must raise the concern within 30 days of the
                    relevant transaction, failing which Sintex's records shall
                    be treated as final and accepted.
                  </li>
                  <li>
                    By enrolling in the Program, the retailer expressly
                    consents to receive communications from Sintex and its
                    authorized representatives, agencies, technology partners,
                    or service providers through SMS, WhatsApp, phone calls,
                    email, mobile application notifications, and any other
                    electronic mode of communication for purposes including but
                    not limited to account verification, reward updates,
                    redemption confirmations, transaction alerts, promotional
                    campaigns, program-related information, service
                    communications, surveys, and customer support. The retailer
                    acknowledges that such communications may continue for the
                    duration of participation in the Program and as otherwise
                    permitted under applicable laws.
                  </li>
                  <li>
                    The retailer shall ensure that the registered mobile
                    number, WhatsApp number, and email address remain active and
                    accessible at all times. Sintex shall not be responsible for
                    any loss of benefits, missed communications, or delays
                    arising due to incorrect, inactive, changed, or inaccessible
                    contact details provided by the retailer.
                  </li>
                  <li>
                    Any rewards, benefits, entitlements, travel incentives, or
                    program privileges earned under the Program are personal to
                    the registered retailer and shall not be transferable,
                    assignable, encashable, or redeemable by any other person or
                    entity unless expressly permitted by Sintex in writing.
                  </li>
                  <li>
                    Participation in the Program does not create any
                    partnership, agency, employment, joint venture, franchise,
                    or other legal relationship between Sintex and the
                    retailer, and the retailer shall not represent itself as
                    being authorized to act on behalf of Sintex.
                  </li>
                  <li>
                    Sintex reserves the right to interpret, administer, and
                    determine eligibility under the Program, and its decisions
                    in respect of participation, rewards, redemptions, disputes,
                    and all other matters relating to the Program shall be
                    final and binding on all participants.
                  </li>
                  <li>
                    Validity of Rewards: Balance rewards available in retailer
                    account on 30 June 2023 would be valid for a period of three
                    years. All rewards accrued to retailer account w.e.f. 01
                    July 2023 would be valid for three years from the date of
                    accrual.
                  </li>
                  <li>
                    The Reward Points can be redeemed in full or in part.
                    Retailer can redeem up to 80% of the accumulated reward
                    points at any stage of the program.
                  </li>
                  <li>
                    Taxes and Insurance, along with documents and other
                    expenses, will have to be borne by the retailer.
                  </li>
                  <li>
                    All issues, concerns and feedbacks pertaining to invoice
                    entries, rewards earned, rewards balance or delivery of
                    rewards should be raised to helpline.
                  </li>
                  <li>
                    Trip eligibility would be considered based on qualified and
                    fully paid billing done during the scheme period. Switching
                    of destination or any other change will not be allowed.
                  </li>
                  <li>
                    Images shown are only for representation. It is the
                    responsibility of the retailer to obtain visa. Company will
                    not be liable for any delay or rejection of visa
                    application.
                  </li>
                  <li>
                    Sintex holds all rights to change and amend the scheme
                    without prior information.
                  </li>
                  <li>
                    In case of any conflict, the company's decision will be
                    final and binding. All disputes related to the same will be
                    resolved as per the jurisdiction of Kalol Court (North
                    Gujarat).
                  </li>
                  <li>
                    Only retailers which have been added, verified and billed in
                    system till 30th September 2023 will be valid for the mega
                    loyalty program with mandatory billing required in all
                    subsequent months till March 2024.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
